export default __webpack_public_path__ + "static/Poppins-Medium-864539c094acfc8dbda224d14f63937d.woff2";